import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard,
  Briefcase,
  FileText,
  Settings,
  Truck,
  Calendar,
  Users,
  Quote,
  Link,
  Route,
  MapPin,
  Factory,
  Package,
  BarChart3,
  Plane,
  Clock,
  Shield,
  ShoppingCart,
  FileCode,
} from 'lucide-react';

export type NavItem = {
  path: string;
  label: string;
  icon: LucideIcon;
};

export type NavGroup = {
  label: string;
  items: NavItem[];
};

/** Top-level item(s) shown above grouped nav (e.g. Dashboard). */
export const NAV_TOP_ITEMS: NavItem[] = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
];

/** Grouped sidebar navigation (matches previous AppSidebar layout). */
export const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Calendar & Planning',
    items: [
      { path: '/delivery-calendar', label: 'Delivery Calendar', icon: Calendar },
      { path: '/holiday-calendar', label: 'Holiday Calendar', icon: Calendar },
    ],
  },
  {
    label: 'User Management',
    items: [
      { path: '/users', label: 'Users', icon: Users },
      { path: '/roles', label: 'Roles', icon: Shield },
    ],
  },
  {
    label: 'Jobs & Orders',
    items: [
      { path: '/jobs', label: 'Jobs', icon: Briefcase },
      { path: '/pallet-management', label: 'Pallet Management', icon: Package },
      { path: '/quotes', label: 'Quotes', icon: Quote },
      { path: '/cartlinks', label: 'Cartlinks', icon: Link },
      { path: '/delivery-management', label: 'Delivery Management', icon: Route },
      {
        path: '/delivery-postcode-management',
        label: 'Delivery Postcode Management',
        icon: MapPin,
      },
    ],
  },
  {
    label: 'Production',
    items: [
      { path: '/production', label: 'Production', icon: Factory },
      { path: '/production-line', label: 'Production Line', icon: Settings },
      { path: '/glass-arrival-jobs', label: 'Glass Arrival Jobs', icon: Package },
      { path: '/delivery-page', label: 'Delivery Page', icon: Truck },
    ],
  },
  {
    label: 'Settings & Data',
    items: [{ path: '/glass-values', label: 'Glass Values', icon: FileText }],
  },
  {
    label: 'Analytics',
    items: [
      { path: '/production-dashboard', label: 'Production Dashboard', icon: BarChart3 },
    ],
  },
  {
    label: 'HR',
    items: [
      { path: '/holidays', label: 'Holidays', icon: Plane },
      { path: '/overtime', label: 'Overtime', icon: Clock },
    ],
  },
];

/** Extra top-level routes (not shown in sidebar) — assignable per role for direct URLs. */
export const NAV_EXTRA_ROUTE_GROUP: NavGroup = {
  label: 'Other routes',
  items: [
    { path: '/orders', label: 'Orders', icon: ShoppingCart },
    { path: '/delivery', label: 'Delivery', icon: Truck },
    { path: '/test/pdf', label: 'Test PDF', icon: FileCode },
  ],
};

/** Full list for role editor checkboxes + ALL_CATALOG_PATHS. */
export const ROLE_PAGE_GROUPS: NavGroup[] = [...NAV_GROUPS, NAV_EXTRA_ROUTE_GROUP];

/** Every path the backend allowlist supports — used for sanity checks. */
export const ALL_CATALOG_PATHS: string[] = [
  ...NAV_TOP_ITEMS.map((i) => i.path),
  ...ROLE_PAGE_GROUPS.flatMap((g) => g.items.map((i) => i.path)),
];
